import React, { Component } from 'react'
import {
    Button,
    Form,
    Select,
  } from "antd";
import { FaSave, FaTimes, FaUndo } from 'react-icons/fa';
import "./FilterModal.scss"
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
  const { Option } = Select;
class FilterModal extends Component {
  formUserRef = React.createRef();
    render() {
      const {Banks,  Employers, FinancingRequestAccountingStatuses } = this.props;
        return (
            <>
                <div className="filter-overlay"></div>
            <div className="filter-modal-wrapper">
                <div className="container">
                    <div className="filter-modal-content">
                    <Form
                        className="add__record--form "
                        layout="vertical"
                        name="step2"
                        ref={this.formUserRef}
                        onFinish={(values) => this.props.handelFilterTab(values)}
                      >
                          <div className="form-header">
                              <h2>تصفيه</h2>
                              <div className="form-header-action">
                                <Button  htmlType="submit"  className="submit-btn">
                                    <FaSave />
                                    حفظ   
                                </Button>
                                <Button className="reload-btn" 
                                onClick={() => {
                                  this.formUserRef.current.resetFields();
                                }}
                                >
                                    <FaUndo />
                                    إعاده   
                                </Button>
                                <i className="close-btn" onClick={this.props.handelCloseFilter}> 
                                    <FaTimes />
                                </i>
                              </div>
                          </div>
                        <div className="form-content">
                        <Form.Item
                            label="حاله الطلب"
                            name="FinanceRequestGeneralStatusId"
                            className="input-holder"
                          >
                            <Select>
                              {FinancingRequestAccountingStatuses?.map(ele => <Option value={ele?.Id} key={ele?.Id} >{ele?.NameLT}</Option>)}
                            </Select>
                          </Form.Item>
                          {/* <Form.Item
                            label="المحيل"
                            name="customerSalary"
                            className="input-holder"
                          >
                            <Input placeholder="" />
                          </Form.Item> */}
                          <Form.Item
                            label="البنك"
                            name="BankId"
                            className="input-holder"
                          >
                            <Select>
                               {Banks?.map(ele => <Option value={ele?.Id} key={ele?.Id} >{ele?.NameLT}</Option>)}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label="جهة العمل"
                            name="EmployerId"
                            className="input-holder"
                          >
                            <Select>
                              {Employers?.map(ele => <Option value={ele?.Id} key={ele?.Id} >{ele?.NameLT}</Option>)}
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label="التزامات"
                            name="HasIndebtednesses"
                            className="input-holder"
                          >
                            <Select>
                              <Option value={true}>نعم</Option>
                              <Option value={false}>لا</Option> 
                            </Select>
                          </Form.Item>
                          <Form.Item
                            label="مدعوم"
                            name="IsSupported"
                            className="input-holder"
                          >
                            <Select>
                              <Option value={true}>نعم</Option>
                              <Option value={false}>لا</Option> 
                            </Select>
                          </Form.Item>
                          
                        </div>
                      </Form>
                    </div>
                </div>
            </div> 
            </>
        )
    }
}

const FilterModalWithRouter = withRouter(FilterModal);
const mapStateToProps = (state) => ({
  currentUser : state.user.currentUser,
  Banks : state.user.metaData.Banks,
  FinanceRequestStatuses : state.user.metaData.FinanceRequestStatuses,
  IndebtednessTypes : state.user.metaData.IndebtednessTypes,
  Employers : state.user.metaData.Employers,
  FinancingRequestAccountingStatuses : state.user.metaData.FinancingRequestAccountingStatuses,
//   FinanceRequestStatuses : state.user.metaData.FinanceRequestStatuses,
//   FinanceRequestStatuses : state.user.metaData.FinanceRequestStatuses,

}) 
export default connect(mapStateToProps)(FilterModalWithRouter);  
